export const PUBLIC_URL = process.env.PUBLIC_URL || '/worker'

export const PATHS = {
	// COMMON
	common: {
		home: '/',
		reset: '/reset',
		signin: '/signin',
		errors: '/errors',
		change_password: '/change_password',
		api: '/api',
		signup: '/signup',
		tracking: '/tracking',
		link_account: '/link_account',
		link_options: '/link_options',
		update_phone: '/update_phone',
		sign_out: '/sign_out',
		candidate_graphql: '/api/graphql/candidate',
		public_graphql: '/api/graphql/public',
		authorization: '/authorization',
		sso_authentication: '/authentication',
		verify_credential: '/verify_credential',
	},
	auth: {
		linkedin: '/linkedin',
		profile_completion: '/profile_completion',
	},

	// CARE
	care: {
		home: '/home',
		signup: '/signup',
		profile: '/profile',
		find_job: '/find_job',
		my_jobs: '/my_jobs',
		credential: '/credential',
		skill_checklist: '/skill_checklist',
		activation: '/activation',
		benefits: '/benefits',
		popular_cities: '/popular_cities',
		urgent_needs: '/sponsored_jobs',
		suggested_jobs: '/suggested_jobs',
		trending_jobs: '/trending_jobs',
		discover: '/discover',
		jobs: '/jobs',
		refer_traveler: '/refer_traveler',
		referrer: '/referrer',
		contact_us: '/contact_us',
		contact_recruiter: '/contact_recruiter',
		settings: '/settings',
		messages: '/messages',
		filter: '/filter',
		edit_filter: '/edit_filter',
		search: '/search',
		last_viewed: '/last_viewed',
		bookmark: '/bookmark',
		job_alerts: '/job_alerts',
		sign_out: '/sign_out',
		email_unsubscribe: '/unsubscribe_emails',
		privacy_policy: '/privacy_policy',
		resource_center: '/resource_center',
		available_jobs: '/discover?type=available_jobs',
		matches_jobs: '/discover?type=matches_jobs',
		featured_jobs: '/discover?type=featured_jobs',
		profile_completion: '/profile_completion',
	},

	banners: {
		first: '/assets/common/banner-1.png',
		second: '/assets/common/banner-2.png',
		third: '/assets/common/banner-3.png',
		four: '/assets/common/banner-4.png',
	},

	worker_portal_prd: 'worker-portal-prd.opusapps.io',
	worker_portal_qa: 'worker-portal-qa.opusasia.io',
	worker_portal_stg: 'worker-portal-stg.opusasia.io',

	// CARE OUTSIDE LINKS
	outside_care: {
		travel_jobs: 'https://www.hosthealthcare.com/travel-jobs/',
		programmaticUrl: 'https://ad.ipredictive.com/d/track/cvt/pixel?acct_id=[trackingid]&cache_buster=[timestamp]',
		conversionPixelUrl: 'https://tags.srv.stackadapt.com/conv?cid=[conversionid]',
		exclusionPixelUrl: 'https://tags.srv.stackadapt.com/rt?sid=[exclusionid]',
		signup: 'https://www.hosthealthcare.com/sign-up',
	},
}
